import * as React from 'react'
import { SVGProps } from 'react'

const SvgArrowUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#arrowUpIcon_svg__a)'>
      <path
        d='M12.285 3.274 9.672.661a2.389 2.389 0 0 0-3.3 0L3.759 3.274a1 1 0 0 0 1.414 1.414l1.854-1.853L7.042 15a1 1 0 1 0 2 0L9.027 2.844l1.844 1.844a1 1 0 1 0 1.414-1.414Z'
        fill='#19A33E'
      />
    </g>
    <defs>
      <clipPath id='arrowUpIcon_svg__a'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgArrowUpIcon
